import { Bell, Clock, CreditCard, ShieldCheck, User, type LucideIcon } from 'lucide-react';

import { ROUTES } from '@/shared/config/routes';

export type SettingsTab = {
  id: 'profile' | 'schedule' | 'notifications' | 'subscription' | 'privacy';
  icon: LucideIcon;
  path: string;
};

export const SETTINGS_TABS: readonly SettingsTab[] = [
  { id: 'profile', icon: User, path: ROUTES.app.settingsProfile },
  { id: 'schedule', icon: Clock, path: ROUTES.app.settingsSchedule },
  { id: 'notifications', icon: Bell, path: ROUTES.app.settingsNotifications },
  { id: 'subscription', icon: CreditCard, path: ROUTES.app.settingsSubscription },
  { id: 'privacy', icon: ShieldCheck, path: ROUTES.app.settingsPrivacy },
];
